import { call } from 'redux-saga/effects';
import { SignalingSocket } from 'services/signaling';

export function* startTranscriptionSaga() {
  yield call(SignalingSocket.send, {
    event: 'startTranscription',
  });
}
